import { Row, Table, Typography } from "antd";
import { useFetchSeasonsByTaskStatus } from "hooks/useSeasonsApi";
import { useState } from "react";
import { useIntl } from "react-intl";
import { createPagination } from "utils/createPagination";
import { useAdminSeasonsColumns } from "../hooks/useAdminSeasonsColumns";
import { SelectTaskStatus } from "./SelectTaskStatus";

type Props = {
  defaultTaskStatusOptionValue: string;
  pageSize: number;
};

export const AdminSeasonList = ({ pageSize, defaultTaskStatusOptionValue }: Props) => {
  const { formatMessage } = useIntl();
  const [taskStatus, setTaskStatus] = useState(defaultTaskStatusOptionValue);
  const [currentPage, setCurrentPage] = useState(1);
  const { isLoading, data: seasonsResponse } = useFetchSeasonsByTaskStatus({
    taskStatus: taskStatus,
    page: currentPage,
    pageSize: pageSize,
  });
  const seasons = seasonsResponse?.data || [];
  const total = seasonsResponse?.meta?.count || 0;

  const columns = useAdminSeasonsColumns();
  const pagination = createPagination(total, pageSize, currentPage);

  const onTaskStatusFilterChanged = (value: string) => {
    setTaskStatus(value);
    setCurrentPage(1);
  };

  return (
    <>
      <Row justify="space-between" align="middle">
        <Typography.Title level={5}>{formatMessage({ id: "adminDashboardPage.seasonTasks.title" })}</Typography.Title>
        <SelectTaskStatus defaultOptionValue={defaultTaskStatusOptionValue} onChange={onTaskStatusFilterChanged} />
      </Row>
      <Table
        dataSource={seasons}
        size="small"
        pagination={pagination}
        onChange={(p: any) => setCurrentPage(p.current)}
        rowKey={(record: any) => record?.entityId + record?.seasonId}
        loading={isLoading}
        columns={columns as any}
      />
    </>
  );
};
